export default "__VITE_ASSET__cecb535a__"